import { useCallback } from "react";
import {
  getEntitySelections,
  removeEntity,
  replaceEntityText,
} from "@sonder/editor/source/core/helpers";
import { useEditorStore } from "@sonder/editor/source/core/stores";
import {
  cancelSearchTermAction,
  useSearchTermStore,
} from "@sonder/editor/source/core/stores/SearchTermStore";
import { DraftEntityOption } from "@sonder/editor/typings/editor";

interface UserMention extends DraftEntityOption {
  type: "USER_MENTION";
  text: string;
}
export const useReplaceCurrentSearchTerm = () => {
  const { state: editorState, setState: setEditorState } = useEditorStore();
  const {
    state: { entityKey },
    dispatch,
  } = useSearchTermStore();

  return useCallback(
    ({ type, text, data }: UserMention) => {
      const entitySelection = getEntitySelections(
        editorState.getCurrentContent(),
        entityKey,
      ).pop();

      if (entitySelection) {
        const { nextEditorState } = replaceEntityText(
          removeEntity(editorState, entityKey),
          entitySelection,
          text,
          { type, mutability: "IMMUTABLE", data },
        );
        dispatch(cancelSearchTermAction());
        setEditorState(nextEditorState);
      }
    },
    [editorState, entityKey],
  );
};
